const getSafeFilename = (title) =>
  String(title || "document")
    .trim()
    .replace(/[^a-z0-9]+/gi, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase() || "document";

/** Downloads the exact self-contained HTML used by the Print V2 preview. */
export const downloadPrintDocument = ({ title, html }) => {
  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");

  anchor.href = objectUrl;
  anchor.download = `${getSafeFilename(title)}.html`;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
};

export { getSafeFilename };
